import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { ProjectActivityTypesDataGrid } from "src/components/views/erp/project/projectActivity/activityTypes/ProjectActivityTypesDataGrid.tsx";

export const Route = createFileRoute("/_authenticated/_shell/project/activityTypes")({
	staticData: { title: i18n.t("activity_types"), legacyViewKey: "projectActivityTypesPage" },
	component: RouteComponent,
});

function RouteComponent() {
	return <ProjectActivityTypesDataGrid />;
}
